import * as batchfileApi from '@/network/api/cardtopup.api.js'

/** requests BatchFiles List
@return {promise} - Tabs request
*/
export const requestBatchFiles = async (context, payload) => {
    const res = await batchfileApi.requestBatchfileChargesList(payload)
    if (res) {
        const data = res.data
        context.commit('SAVE_BATCHFILES', { pageNumber: payload.pageNumber, data: data })
    }
    return res
}

/** requests BatchFiles Detail
@return {promise} - Tabs request
*/
export const requestBatchFileDetail = async (context, payload) => {
    const res = await batchfileApi.requestBatchfileChargeDetail(payload)
    return res
}

/* ***********************************************
*                   CLEAR ACTIONS                *
*********************************************** */
export const clearFeatureStates = async (context, payload) => {
    context.commit('CLEAR_FEATURE_STATE')
}
